import { FormikProps } from "formik";
import { FormValues } from "../organisms";

export const hasAnyErrors = (err: unknown): boolean => {
    if (!err) return false;
    if (typeof err === 'string') return true;
    if (Array.isArray(err)) return err.some(hasAnyErrors);
    if (typeof err === 'object') {
      return Object.values(err as Record<string, unknown>).some(hasAnyErrors);
    }

    return false;
  };

export  const markErrorsTouched = (errors: any, parentKey = '', formikRef: React.RefObject<FormikProps<FormValues>>) => {
    if (Array.isArray(errors)) {
      errors.forEach((err, idx) => {
        const fieldPath = parentKey ? `${parentKey}[${idx}]` : `[${idx}]`;
        if (err && typeof err === 'object') {
          markErrorsTouched(err, fieldPath, formikRef);
        } else {
          formikRef.current?.setFieldTouched(fieldPath, true, false);
        }
      });
    } else if (typeof errors === 'object' && errors !== null) {
      Object.entries(errors).forEach(([key, value]) => {
        const fieldPath = parentKey ? `${parentKey}.${key}` : key;
        if (value && typeof value === 'object') {
          markErrorsTouched(value, fieldPath, formikRef);
        } else {
          formikRef?.current?.setFieldTouched(fieldPath, true, false);
        }
      });
    }
  };